var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2319_1991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83556 1.71666L16.5022 4.80208V10.4021C16.5022 13.1521 14.971 15.6979 12.6001 16.8875L9.83556 18.275L7.06889 16.8875C4.69806 15.6979 3.16889 13.1521 3.16889 10.4021V4.80208L9.83556 1.71666ZM9.83556 -0.00209045C9.66271 -0.00123122 9.49212 0.0371533 9.33556 0.11041L2.22306 3.40208C2.00522 3.50609 1.82164 3.67018 1.69393 3.87502C1.56622 4.07987 1.49971 4.31694 1.50223 4.55833V10.4021C1.48935 12.047 1.93292 13.6632 2.78362 15.0711C3.63433 16.479 4.85882 17.6234 6.32098 18.3771L9.30223 19.8729C9.46683 19.9565 9.64885 20.0001 9.83348 20.0001C10.0181 20.0001 10.2001 19.9565 10.3647 19.8729L13.346 18.3771C14.8089 17.624 16.0343 16.4799 16.8857 15.0719C17.7372 13.664 18.1814 12.0474 18.1689 10.4021V4.56874C18.1712 4.32714 18.1044 4.08991 17.9763 3.88503C17.8482 3.68016 17.6642 3.5162 17.446 3.41249L10.3314 0.11041C10.1761 0.0377391 10.007 -0.000631035 9.83556 -0.00209045V-0.00209045Z",
    fill: "#84B0DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.69579 12.1563L7.02913 10.425C6.914 10.3059 6.85087 10.146 6.8536 9.98032C6.85634 9.81469 6.92471 9.65692 7.04371 9.54167L7.33538 9.25209C7.45476 9.13723 7.61486 9.07447 7.78049 9.07759C7.94613 9.08072 8.10375 9.14948 8.21871 9.26876L9.13954 10.2229L11.4312 7.83959C11.4884 7.77737 11.5577 7.7274 11.6348 7.69271C11.7119 7.65802 11.7952 7.63933 11.8797 7.63777C11.9643 7.63621 12.0482 7.65182 12.1265 7.68364C12.2048 7.71547 12.2759 7.76285 12.3354 7.82292L12.6291 8.12292C12.7481 8.23817 12.8165 8.39594 12.8192 8.56157C12.822 8.7272 12.7588 8.88715 12.6437 9.00626L9.59579 12.1563C9.53749 12.2167 9.46759 12.2649 9.39027 12.2977C9.31296 12.3306 9.22981 12.3475 9.14579 12.3475C9.06178 12.3475 8.97863 12.3306 8.90131 12.2977C8.824 12.2649 8.7541 12.2167 8.69579 12.1563Z",
    fill: "#84B0DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2319_1991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/Icon-2.43309e85d96f624f9647e30465bc379c.svg";
export { ForwardRef as ReactComponent };